import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { H3 } from '@r1-frontend/ui-react/components/typography/heading';
import TextWrapper from '@r1-frontend/ui-react/components/typography/TextWrapper';

import { DecoderInfo } from '~/src/features/full-buy/components/DecoderInfo';
import { DecoderList } from '~/src/features/full-buy/containers/DecoderList';
import { MainLayout } from '~/src/features/full-buy/containers/MainLayout/MainLayout';
import { skipEquipmentTvStep } from '~/src/features/full-buy/store/actions/skipEquipmentTvStep';

export const EquipmentsTv = (): JSX.Element => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(skipEquipmentTvStep());
    }, []);

    return (
        <MainLayout>
            <TextWrapper $lastIndent={false}>
                <H3>Выберите ТВ-приставку</H3>
                <DecoderInfo/>
            </TextWrapper>
            <DecoderList />
        </MainLayout>
    );
};
